(function () {
  'use strict';

  var root = document.querySelector('[data-mndfrme-exit-feedback]');
  if (!root) return;

  var shownKey = 'mndfrme_exit_feedback_shown';
  var submittedKey = 'mndfrme_exit_feedback_submitted';
  var armedKey = 'mndfrme_exit_feedback_armed';
  var checkoutKey = 'mndfrme_exit_feedback_checkout_started';
  var guardKey = 'mndfrme_exit_feedback_guarded';
  var selectedReason = '';
  var hasBound = false;

  var closeButtons = root.querySelectorAll('[data-mndfrme-exit-dismiss]');
  var submitButton = root.querySelector('[data-mndfrme-exit-submit]');
  var formState = root.querySelector('[data-mndfrme-exit-form]');
  var thanksState = root.querySelector('[data-mndfrme-exit-thanks]');
  var radios = root.querySelectorAll('input[name="mndfrme_exit_reason"]');

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function storageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function hasSubmitted() {
    return storageGet(window.localStorage, submittedKey) === 'true';
  }

  function hasShown() {
    return storageGet(window.sessionStorage, shownKey) === 'true';
  }

  function isArmed() {
    return storageGet(window.sessionStorage, armedKey) === 'true';
  }

  function checkoutStarted() {
    return storageGet(window.sessionStorage, checkoutKey) === 'true';
  }

  function canShow() {
    return isArmed() && !checkoutStarted() && !hasShown() && !hasSubmitted() && !root.classList.contains('is-open');
  }

  function installBackGuard() {
    if (!window.history || !window.history.pushState) return;
    if (storageGet(window.sessionStorage, guardKey) === 'true') return;

    try {
      var baseState = Object.assign({}, window.history.state || {}, { mndfrmeExitBase: true });
      var guardState = Object.assign({}, window.history.state || {}, { mndfrmeExitGuard: true });
      window.history.replaceState(baseState, document.title, window.location.href);
      window.history.pushState(guardState, document.title, window.location.href);
      storageSet(window.sessionStorage, guardKey, 'true');
    } catch (error) {
      storageRemove(window.sessionStorage, guardKey);
    }
  }

  function armFeedback() {
    if (hasSubmitted() || checkoutStarted()) return;
    storageSet(window.sessionStorage, armedKey, 'true');
    installBackGuard();
  }

  function cartHasItems(event) {
    var detail = event && event.detail ? event.detail : {};
    var itemCount = detail.data && typeof detail.data.itemCount === 'number' ? detail.data.itemCount : null;
    if (itemCount === null && detail.resource && typeof detail.resource.item_count === 'number') {
      itemCount = detail.resource.item_count;
    }

    return itemCount === null || itemCount > 0;
  }

  function isCartDrawerEvent(event) {
    if (!event || !event.target || !event.target.closest) return false;
    return Boolean(event.target.closest('cart-drawer-component'));
  }

  function isCartDrawerCloseTarget(target) {
    if (!target || !target.closest) return false;
    return Boolean(target.closest('cart-drawer-component .cart-drawer__close-button, cart-drawer-component .close-button'));
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function isCartDrawerOpen() {
    var drawer = getCartDrawer();
    if (!drawer) return false;
    var dialog = drawer.querySelector('[data-testid="cart-drawer-dialog"], .cart-drawer__dialog');
    return Boolean(dialog && dialog.open);
  }

  function ensureArmedFromCart() {
    if (isArmed()) return Promise.resolve(true);
    if (hasSubmitted() || checkoutStarted()) return Promise.resolve(false);

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.item_count) return false;
        storageSet(window.sessionStorage, armedKey, 'true');
        installBackGuard();
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function openAfterCartIntent(delay) {
    window.setTimeout(function () {
      ensureArmedFromCart().then(function (armed) {
        if (armed) openFeedback();
      });
    }, delay || 0);
  }

  function markCheckoutStarted() {
    storageSet(window.sessionStorage, checkoutKey, 'true');
    storageRemove(window.sessionStorage, armedKey);
    storageRemove(window.sessionStorage, guardKey);
  }

  function openFeedback() {
    if (!canShow()) return;
    storageSet(window.sessionStorage, shownKey, 'true');
    storageRemove(window.sessionStorage, guardKey);
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
  }

  function closeFeedback() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
  }

  function submitFeedback() {
    if (!selectedReason) return;
    storageSet(window.localStorage, submittedKey, 'true');
    storageSet(window.localStorage, 'mndfrme_exit_feedback_reason', selectedReason);
    storageRemove(window.sessionStorage, armedKey);
    storageRemove(window.sessionStorage, guardKey);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mndfrme_exit_feedback',
      reason: selectedReason,
      page: window.location.href
    });

    if (window.Shopify && window.Shopify.designMode) {
      console.log('[MNDFRME exit feedback]', selectedReason);
    }

    if (formState) formState.hidden = true;
    if (thanksState) thanksState.hidden = false;

    window.setTimeout(closeFeedback, 1500);
  }

	  function isAddToCartTarget(target) {
	    if (!target || !target.closest) return false;
	    if (target.closest('[data-direct-checkout="true"], .shopify-payment-button__button')) return false;
	    return Boolean(target.closest('add-to-cart-component, button[name="add"], .add-to-cart-button, [data-add-to-cart]'));
	  }

	  function isCheckoutTarget(target) {
	    if (!target || !target.closest) return false;
	    return Boolean(target.closest('[data-direct-checkout="true"], .shopify-payment-button__button, button[name="checkout"], a[href*="/checkout"], [formaction*="/checkout"]'));
	  }

  function bind() {
    if (hasBound || hasSubmitted()) return;
    hasBound = true;

    if (isArmed() && !checkoutStarted()) installBackGuard();

    document.addEventListener('click', function (event) {
      if (isCheckoutTarget(event.target)) {
        markCheckoutStarted();
        return;
      }

      if (isCartDrawerCloseTarget(event.target)) {
        openAfterCartIntent(220);
        return;
      }

      if (isAddToCartTarget(event.target)) {
        window.setTimeout(armFeedback, 250);
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]') : null;
      if (form && !form.querySelector('[data-direct-checkout="true"]:focus')) {
        window.setTimeout(armFeedback, 250);
      }
    }, true);

    document.addEventListener('cart:update', function (event) {
      if (!cartHasItems(event)) return;
      if (event.detail && event.detail.data && event.detail.data.didError) return;
      if (checkoutStarted()) return;
      armFeedback();
    });

    document.addEventListener('dialog:close', function (event) {
      if (!isCartDrawerEvent(event)) return;
      openAfterCartIntent(80);
    }, true);

    window.addEventListener('popstate', function () {
      if (isCartDrawerOpen()) {
        var drawer = getCartDrawer();
        if (drawer && typeof drawer.close === 'function') drawer.close();
        openAfterCartIntent(220);
        return;
      }

      if (!canShow()) {
        openAfterCartIntent(0);
        return;
      }

      openFeedback();

      try {
        window.history.pushState({ mndfrmeExitAfterPrompt: true }, document.title, window.location.href);
      } catch (error) {
        return;
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeFeedback);
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        selectedReason = radio.value;
        if (submitButton) submitButton.disabled = false;
      });
    });

    if (submitButton) submitButton.addEventListener('click', submitFeedback);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeFeedback();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
